import { useAuthStore } from '@clarix/auth-store';

/**
 * Support routes are workspace-slug-prefixed (`/:slug/support/*`). The gateway
 * routes by the slug segment but injects workspace identity from the JWT, so
 * the slug just has to be the active workspace. Read it from the auth store
 * (same source the api-client sends as X-Workspace-Slug).
 */
export function supportBase(): string {
  const slug = useAuthStore.getState().workspaceSlug;
  if (!slug) throw new Error('No active workspace selected');
  return `/${slug}/support`;
}
